module.exports = __webpack_public_path__ + "assets/campaign-edit-active.a554deea.svg";